import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
// import { Container } from './styles';

const SkeletonComp = ({ isDefault = false, ...rest }) => {
  if (!isDefault) {
    return (
      <SkeletonTheme color="#fff" highlightColor="#efefef">
        <Skeleton {...rest} />
      </SkeletonTheme>
    );
  } else {
    return (
      <SkeletonTheme >
        <Skeleton {...rest} />
      </SkeletonTheme>
    )
  }
}

export default SkeletonComp;